import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-stepper.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-stepper.component.scss?ngResource";
import { Component } from '@angular/core';
let ViewApplicationStepperComponent = class ViewApplicationStepperComponent {
    constructor() { }
    ngOnInit() {
    }
    static ctorParameters = () => [];
};
ViewApplicationStepperComponent = __decorate([
    Component({
        selector: 'app-view-application-stepper',
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationStepperComponent);
export { ViewApplicationStepperComponent };
